import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  FaChevronDown,
  FaChevronUp,
  FaFire,
  FaTint,
  FaSmog,
  FaVirus,
} from 'react-icons/fa';
import { MdPublic } from 'react-icons/md';
import { BsCalendar3 } from 'react-icons/bs';
import { setFilters, fetchFires } from '../../Redux/mapSlice';
import './filters.css';

const Filters = () => {
  const dispatch = useDispatch();
  const [showCrisis, setShowCrisis] = useState(true);
  const [showRegion, setShowRegion] = useState(true);
  const [showTime, setShowTime] = useState(true);

  const [crisis, setCrisis] = useState('Wildfire');
  const [region, setRegion] = useState('Global');
  const [date, setDate] = useState('');

  const handleApply = () => {
    const source = crisis === 'Wildfire' ? 'VIIRS_SNPP_NRT' : 'VIIRS_SNPP_NRT';
    const area = region === 'Global' ? 'world'
               : region === 'USA' ? 'USA'
               : region === 'Asia' ? '60,-10,150,60'
               : region === 'Europe' ? '-10,35,40,70'
               : 'world';

    const days = 5;

    dispatch(setFilters({ source, area, days }));
    dispatch(fetchFires({ source, area, days }));
  };

  return (
    <div
      style={{
        backgroundColor: '#ffffff',
        padding: '1.5rem',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
        margin: '2rem 0',
      }}
    >
      <h5 className="mb-4" style={{ fontWeight: '600' }}>🔍 Filters</h5>

      {/* Crisis Type */}
      <div className="mb-4">
        <div
          onClick={() => setShowCrisis(!showCrisis)}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            cursor: 'pointer',
            fontWeight: '500',
            fontSize: '16px',
            paddingBottom: '0.5rem',
          }}
        >
          <span><FaFire className="me-2" style={{ color: '#e25822' }} /> Crisis Type</span>
          {showCrisis ? <FaChevronUp /> : <FaChevronDown />}
        </div>
        {showCrisis && (
          <select value={crisis} onChange={(e) => setCrisis(e.target.value)} className="form-control mt-3 shadow-sm rounded">
            <option>Wildfire</option>
            <option>Flood</option>
            <option>Pollution</option>
            <option>Disease</option>
          </select>
        )}
      </div>

      {/* Region */}
      <div className="mb-4">
        <div
          onClick={() => setShowRegion(!showRegion)}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            cursor: 'pointer',
            fontWeight: '500',
            fontSize: '16px',
            paddingBottom: '0.5rem',
          }}
        >
          <span><MdPublic className="me-2" style={{ color: '#4a90e2' }} /> Region</span>
          {showRegion ? <FaChevronUp /> : <FaChevronDown />}
        </div>
        {showRegion && (
          <select value={region} onChange={(e) => setRegion(e.target.value)} className="form-control mt-3 shadow-sm rounded">
            <option>Global</option>
            <option>USA</option>
            <option>Asia</option>
            <option>Europe</option>
          </select>
        )}
      </div>

      {/* Time Range */}
      <div className="mb-2">
        <div
          onClick={() => setShowTime(!showTime)}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            cursor: 'pointer',
            fontWeight: '500',
            fontSize: '16px',
            paddingBottom: '0.5rem',
          }}
        >
          <span><BsCalendar3 className="me-2" style={{ color: '#0d6efd' }} /> Time Range</span>
          {showTime ? <FaChevronUp /> : <FaChevronDown />}
        </div>
        {showTime && (
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className="form-control mt-3 shadow-sm rounded"
          />
        )}
      </div>

      <button onClick={handleApply} className="btn btn-primary mt-3">Apply Filters</button>
    </div>
  );
};

export default Filters;
